if (!customElements.get('yhr-colour-edit')) {
  customElements.define('yhr-colour-edit', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = {signal: this.cleanup.signal};
      const dialog = this.querySelector('dialog');
      if (!dialog?.showModal) return;
      this.dialog = dialog;
      const heading = this.querySelector('[data-edit-heading]');
      const content = this.querySelector('[data-edit-content]');
      let trigger, keyboard = false;
      this.querySelectorAll('[data-open-colour]').forEach(link => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('blur', () => link.removeAttribute('data-pointer-return'), options);
        link.addEventListener('pointerdown', () => link.removeAttribute('data-pointer-return'), options);
        link.addEventListener('keydown', () => link.removeAttribute('data-pointer-return'), options);
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const template = [...this.querySelectorAll('template[data-colour-template]')].find(t => t.dataset.colourTemplate === link.dataset.openColour);
          if (!template) return;
          event.preventDefault();
          trigger = link;
          keyboard = event.detail === 0;
          heading.textContent = template.dataset.heading;
          content.replaceChildren(template.content.cloneNode(true));
          dialog.showModal();
        }, options);
      });
      dialog.querySelector('[data-close-dialog]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...dialog.querySelectorAll('button, a[href]')];
        const first = controls[0], last = controls.at(-1);
        if (event.shiftKey && document.activeElement === first) {event.preventDefault(); last.focus();}
        else if (!event.shiftKey && document.activeElement === last) {event.preventDefault(); first.focus();}
      }, options);
      dialog.addEventListener('click', event => {
        const r = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        if (!trigger) return;
        if (!keyboard) trigger.setAttribute('data-pointer-return', '');
        trigger.focus({preventScroll: true});
      }, options);
    }
    disconnectedCallback() {
      this.cleanup?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
